import React from 'react';
import {
  makeStyles,
  tokens,
  Text,
} from '@fluentui/react-components';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import PageSidebar from './sidebar';
import PageContent from './contentbar';
//import PageBreadcrumb from './breadcrumb';
import Headerbar from './headerbar';

const useStyles = makeStyles({
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  bodyContainer: {
    display: 'flex',
    flex: 1,
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  footer: {
    textAlign: 'center',
    padding: tokens.spacingVerticalL,
    backgroundColor: tokens.colorNeutralBackground1,
    borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
  }
});

const PageLayout: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Headerbar />
      <div className={styles.bodyContainer}>
        <PageSidebar />
        <div className={styles.mainContent}>
          {/*<PageBreadcrumb />*/}
          <AuthenticatedTemplate>
            <PageContent />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <Text style={{
              fontSize: "1.5rem",
              marginLeft: "48px",
              marginTop: "48px",
              display: "block"
            }}>Please log in to continue</Text>
          </UnauthenticatedTemplate>
        </div>
      </div>
      <footer className={styles.footer}>
        <Text>
          ©{new Date().getFullYear()}
        </Text>
      </footer>
    </div>
  );
};

export default PageLayout;
